import type {MouseEvent} from "react";
import cn from "classnames";

import {Picture} from "@pg-design/picture-module";

import * as styles from "./DataTableCellPictureWithName.module.css";

export interface IDataTableCellPictureWithNameProps {
    src: string;
    name: string;
    onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

export const DataTableCellPictureWithName = (props: IDataTableCellPictureWithNameProps) => (
    <div className={cn(styles.cell, Boolean(props.onClick) && styles.cursorPointer)} onClick={props.onClick}>
        <Picture className={styles.picture} sources={[{src: props.src, minWidthPX: 0, width: 100, height: 80}]} alt={`${props.name}`} />

        {props.name}
    </div>
);
import type {MouseEvent} from "react";
import cn from "classnames";

import {Picture} from "@pg-design/picture-module";

import * as styles from "./DataTableCellPictureWithName.module.css";

export interface IDataTableCellPictureWithNameProps {
    src: string;
    name: string;
    onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

export const DataTableCellPictureWithName = (props: IDataTableCellPictureWithNameProps) => (
    <div className={cn(styles.cell, Boolean(props.onClick) && styles.cursorPointer)} onClick={props.onClick}>
        <Picture className={styles.picture} sources={[{src: props.src, minWidthPX: 0, width: 100, height: 80}]} alt={`${props.name}`} />

        {props.name}
    </div>
);
